import styled from '@emotion/styled';
import { COLORS } from "../../constants/Theme";
import { ComponentZindex } from "../../constants/zindex";
export const RootContainer = styled.div `
	position: fixed;
	top: 0;
	left: 0;
	z-index: ${(props) => props.zIndex || ComponentZindex.MODAL};
	height: 100%;
	width: 100%;
	background-color: rgba(0, 0, 0, 0.6);
	display: flex;
	align-items: center;
	justify-content: center;
`;
export const CentralContainer = styled.div `
	width: ${(props) => { var _a; return (_a = props.width) !== null && _a !== void 0 ? _a : '640px'; }};
	background-color: ${COLORS.surface.standard};
	border-radius: 4px;
	position: relative;
	display: flex;
`;
export const CloseButtonContainer = styled.div `
	height: 36px;
	width: 36px;
	border-radius: 50%;
	position: absolute;
	right: 0;
	top: 0;
	translate: 50% -50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${COLORS.surface.standard};
	border: 1px solid ${COLORS.stroke.primary};
	cursor: pointer;
	z-index: 2;
`;
//# sourceMappingURL=modal.styled.js.map